import styled from 'styled-components';

export const StyledInputIcon = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${({ $prefix }) => $prefix && '15px'};
  right: ${({ $suffix }) => $suffix && '15px'};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ $invalid }) => ($invalid ? 'var(--danger)' : 'var(--text-color-50)')};
  font-size: var(--font-size-lg);
  background: none;
  border: none;
  padding: 0;
  z-index: 1;
  line-height: 1;
  pointer-events: ${({ $suffix }) => ($suffix ? 'auto' : 'none')};

  ${({ disabled }) => disabled && 'opacity: 0.5;'}

  svg {
    display: block;
    flex-shrink: 0;
    stroke: currentColor;
    color: inherit;
  }

  img {
    display: block;
    width: 22px;
    height: 22px;
    object-fit: contain;
    filter: brightness(0) saturate(100%) invert(44%) sepia(10%) saturate(650%) hue-rotate(182deg);
    opacity: 0.9;
  }

  i {
    display: block;
  }
`;
